import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { getFootprintingFarmPrimaryDataByYear } from "services";

import { getLocalKlimVar, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_FARM_PRIMARY_DATA } from "consts";

export const useGetFootprintingFarmPrimaryData = (farmId: string, year: number) => {
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getLocalKlimVar("token");

  return useQuery({
    queryKey: [FOOTPRINTING_FARM_PRIMARY_DATA, farmId, year],
    queryFn: () => getFootprintingFarmPrimaryDataByYear(year),
    enabled: !!farmId && !!year && !!user && !!token && !!carbonProgram?.platformFeatures?.footprinting?.enabled,
    gcTime: 60000,
    retry: (_, error) => {
      if (!(error instanceof AxiosError)) return true;

      if (error.response?.status === 404 || error.response?.status === 418) return false;
      return true;
    },
  });
};
